import { Component } from "@angular/core";
import { SharedComponents } from "../../../components/shared.module";
import { CodeQualityComponent } from "../../../components/smart_test-review-automated/code-quality/code-quality.component";
import { MappingOverviewComponent } from "../../../components/smart_test-review-automated/mapping-overview/mapping-overview.component";
import { MappingReviewComponent } from "../../../components/smart_test-review-automated/mapping-review/mapping-review.component";
import { UploadTestCaseDocComponent } from "../../../components/smart_test-review-automated/upload-test-case-doc/upload-test-case-doc.component";
import { BaseLayoutComponent } from "../../base-layout.component";

/**
 * A component that represents the "Smart Test Review Automated" workflow, extending the base layout component.
 * This component integrates multiple steps, each handled by a specific child component,
 * to provide a comprehensive review of test cases, mappings, and code quality.
 */
@Component({
  selector: "app-smart-test-review-automated",
  standalone: true,
  imports: [...SharedComponents],
  templateUrl: "./smart-test-review-automated.component.html",
  styleUrl: "./smart-test-review-automated.component.scss",
})
export class SmartTestReviewAutomatedComponent extends BaseLayoutComponent {

  /**
   * Data for the workflow steps to be displayed in the component.
   * Each step includes a title, the associated component, and metadata to configure its view.
   */
  stepData: any[] = [
    {
      title: "Test Case Document",
      component: UploadTestCaseDocComponent,
      data: {
        display_name: "Upload Test Case Document",
        view: "uploadTestCaseDoc"
      },
    },
    {
      title: "Mappings Overview",
      component: MappingOverviewComponent,
      data: {
        display_name: "Mappings Overview",
        view: "mappingsOverview",
      },
    },
    {
      title: "Mappings Review",
      component: MappingReviewComponent,
      data: {
        display_name: "Mappings Review",
        view: "mappingsReview",
      },
    },
    {
      title: "Code Quality",
      component: CodeQualityComponent,
      data: {
        display_name: "Code Quality",
        view: "codeQuality",
      },
    }
  ];
}
